import React, { useEffect } from "react";
import Card from "@material-ui/core/Card";
import Divider from "@material-ui/core/Divider";
import { NavLink } from "react-router-dom";
import Link from "@material-ui/core/Link";
import Box from "@material-ui/core/Box";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from "@material-ui/core/Button";
import { themeButtons } from "../../../css/themeButtons";
import { usePrevious } from "../CustomHook/usePrevious";

const progressStage = (progress) => {
  if (progress <= 33) {
    return "bg-danger"
  }
  if (progress > 33 && progress < 66) {
    return "bg-warning"
  }
  return "bg-success"
}


const AdditionInfoTextLine = ({ text, type }) => {

  return (
    <div className="addition-info__text-line">
      <FontAwesomeIcon icon={["far", "check-circle"]} className={`text-${type} me-1`}/>
      <span>{text}</span>
    </div>
  )
}

const ProgressItem = ({ text, type, link }) => {

  return (
    <div>
      <Link className="progress-card__link" component={NavLink} underline="none" to={link}>
        <FontAwesomeIcon icon={["far", "check-circle"]} className={`text-${type} me-1`}/>
        <span>{text}</span>
      </Link>
    </div>
  )
}


const FunctionSidebar = (props) => {
  const {
    objectId,
    progressItemsHasProblem,
    progress,
    priority,
    photoWarning,
    roomsWarning,
    disabledRoom,
    hasActiveRoom,
    contractStage,
    hasActiveContractBtn,
    userRole,
    getObjectsList,
    clearSearch
  } = props


  const hasActiveContractBtnPrev = usePrevious(hasActiveContractBtn)
  useEffect(() => {
    if (hasActiveContractBtn && hasActiveContractBtn !== hasActiveContractBtnPrev) {
      if (userRole !== "MODERATOR") {
        getObjectsList()
      } else {
        clearSearch()
      }

    }

  }, [hasActiveContractBtn])

  const progressItemType = {
    1: "danger",
    2: "warning",
    3: "success",
  }


  const progressItemInfo = {
    "description": { text: 'Описание', link: `/lk/${objectId}/about` },
    "contact": { text: 'Контакты', link: `/lk/${objectId}/contacts` },
    "location": { text: 'Расположение', link: `/lk/${objectId}/distances` },
    "photo": { text: 'Добавьте не менее 5 фотографий объекта', link: `/lk/${objectId}/photo` },
    "rules": { text: 'Правила проживания', link: `/lk/${objectId}/conditions` },
    "services": { text: 'Заполните услуги', link: `/lk/${objectId}/services` },
    "roomPhotos": {
      text: 'Добавьте не менее 3 фотографий номера',
      link: `/lk/${objectId}/rooms/${disabledRoom && disabledRoom.id}`
    },
    "prices": { text: 'Добавьте цены номера', link: `/lk/${objectId}/calendar/${disabledRoom && disabledRoom.id}` },
    "availability": {
      text: 'Заполните занятость номера',
      link: `/lk/${objectId}/busy-calendar/${disabledRoom && disabledRoom.id}`
    },
    "dontHaveRoom": { text: 'Добавьте номера', link: `/lk/${objectId}/rooms/new` },
    "activeRoom": { text: 'Добавьте номера', link: `/lk/${objectId}/rooms/new` },
    "verifiedUserStatus": { text: 'Подтвердите аккаунт', link: `/lk/profile` },
  }


  const buttons = themeButtons()
  return (
    <div className="function-sidebar">
      {photoWarning && <Box className="alert alert-warning d-none d-lg-block">
        Фотографии можно менять местами. Наведите мышкой на нужную фотографию, зажмите левой кнопкой и
        перетащите в нужное место.
        <br/>
        На странице объекта фотографии будут в том же порядке как отображены здесь.
        <br/> <b>Первые 4 фотографии из этой таблицы будут отображены как анонсовые на страницах каталога</b>
      </Box>}
      {roomsWarning && <Box className="alert alert-warning d-none d-lg-block">
        Номера можно менять местами. Наведите мышкой на нужный номер, зажмите левой кнопкой и
        перетащите в нужное место.
        <br/>
        <b>На странице объекта номера будут в том же порядке как отображены здесь.</b>

      </Box>}

      <Card variant="outlined" className="card progress-card">
        <div className="p-3 addition-info border-bottom">
          <div className="addition-info__title">Необходимо заполнить обязательные пункты</div>
        </div>
        <div className="p-3">

          <span>Заполнено на: </span>
          <div className="progress">
            {progress ? <div className={`progress-bar progress-bar-striped ${progressStage(progress)}`}
                             role="progressbar"
                             style={{ width: `${progress}%` }}>
                {progress}%
              </div>
              : <div className={`progress-bar progress-bar-striped`}
                     role="progressbar"
                     style={{ width: "100%", color: "#222" }}>
                0%
              </div>}

          </div>
          {hasActiveContractBtn && <Button component={NavLink} to={`/lk/contracts/${objectId}`}
                                           className={`${buttons.btnGreen} mb-3 w-100`}
          >
            Заключить договор
          </Button>}


          {progressItemsHasProblem && priority && progressItemsHasProblem.map(item => {
            if (item !== "disabledRoom") {
              return <ProgressItem key={item}
                                   text={progressItemInfo[item].text}
                                   type={progressItemType[priority[item] ? priority[item] : hasActiveRoom !== 'Y' ? 1 : 3]}
                                   link={progressItemInfo[item].link}/>
            }

          })}


        </div>
        <Divider/>
        <div className="card-footer">

          <AdditionInfoTextLine text="Обязательные пункты" type="danger"/>
          <AdditionInfoTextLine text="Расширенная информация об объекте" type="warning"/>
          <AdditionInfoTextLine text="Полная информация об объекте" type="success"/>

        </div>
      </Card>
    </div>
  )
}

export default FunctionSidebar
